exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".SideButtons-module__buttons-wrapper___3UdNB{height:100%;display:flex;justify-content:space-around;align-items:flex-start}.SideButtons-module__buttons-wrapper___3UdNB .SideButtons-module__buttons___3wixB{width:100%;top:128px;display:grid;gap:24px;position:sticky;position:-webkit-sticky;height:-webkit-fit-content;height:-moz-fit-content;height:fit-content}.SideButtons-module__buttons-wrapper___3UdNB .SideButtons-module__buttons___3wixB span{font-weight:500}@media (min-width:1325px){.SideButtons-module__buttons-wrapper___3UdNB{grid-column:2;align-content:start}}", ""]);

// exports
exports.locals = {
	"buttons-wrapper": "SideButtons-module__buttons-wrapper___3UdNB",
	"buttons": "SideButtons-module__buttons___3wixB"
};